import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { Zip } from '@ionic-native/zip/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  public apiUrl: string = "https://enetcloud-uk6-test-enetreality-api.azurewebsites.net/";
  public getProjectApi: string = "api/export/ExportUnpackagedProject/";
  public getProjectInformationApi: string = "api/project/Packager/";
  public downloadProjectApi: string = "";
  public fileTransfer: FileTransferObject;
  public downloading: boolean;
  public downloadProgress: number;
  public statusMessage: string;
  public timer;
  public Projects = [];
  public browser = null;
  public oculus = false;
  public isbrowser = true;

  constructor(
    public httpClient: HttpClient,
    private transfer: FileTransfer,
    private zip: Zip,
    private iab: InAppBrowser
  ) { 
    this.downloading = false;
    this.downloadProgress = 0;
    this.fileTransfer = this.transfer.create();

    if (localStorage.getItem("projects") != null)
      this.Projects = JSON.parse(localStorage.getItem("projects"));

    if (this.oculus) {
      window.location.href = "https://enetcloud-uk6-test-enetreality-companion.azurewebsites.net/";

      setTimeout(() => {
        navigator['app'].exitApp();
      }, 1000);
    }
  }

  public getProjectInformation(code) {
    if (code.length == 4){
      this.httpClient.get(this.apiUrl + this.getProjectInformationApi + code).subscribe((data: any) => {
        try {
          this.downloading = true;
          this.downloadProgress = 0;
          var project = data;
          this.Projects.push(project);
          localStorage.setItem("projects", JSON.stringify(this.Projects));
          this.getProject(project.ProjectId);
        } catch(e) {
          this.downloading = false;
          this.downloadProgress = 0;
          this.statusMessage = "Project could not be found...";
        }
      },
      error => {
        this.downloading = false;
        this.downloadProgress = 0;
        this.statusMessage = "Project could not be found...";
      });
    } else {
      this.downloading = false;
      this.downloadProgress = 0;
      this.statusMessage = "Project code is invalid...";
    }
  }

  public getProject(code) {
    if (this.browser == null) {
      this.downloading = true;
      this.downloadProgress = 50;
      this.httpClient.get(this.apiUrl + this.getProjectApi + code).subscribe(data => {
        this.downloading = false;
        this.statusMessage = "There was a problem accessing the project...";
      }, 
      error => {
        try {
          if (error.error.text.indexOf('Project/') >= 0) {
            this.downloadProject(error.error.text);

            this.timer = setTimeout(() => {
              if (this.downloading == true)
              {
                this.downloading = false;
                this.statusMessage = "There was a problem accessing the project...";
              }
            }, 10000);
          } else {
            this.downloading = false;
            this.downloadProgress = 0;
            this.statusMessage = "Project could not be found...";
          }
        } catch (ex) {
          this.downloading = false;
          this.downloadProgress = 0;
          this.statusMessage = "Project could not be found...";
        }
      });
    }
  }

  public downloadProject(url) {
    clearTimeout(this.timer);
    this.downloading = false;
    this.downloadProgress = 0;
    if (this.isbrowser) {
      window.location.href = this.apiUrl + url;
    }
  }
}
